import React from "react";
import RichText2 from "./WhatToseeRichText2";
export default function AboutUs(props) {
  return (
    <div>
      <div className="city-state-container highlights insureonline">
        <div className="row">
          <div className="col-sm-6">
            <RichText2
              Description={props?.data?.content?.description}
            ></RichText2>
          </div>
          <div className="col-sm-6">
            <img
              src={props?.data?.content?.image.filename}
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
